import {
    type FC,
    type ReactNode,
    useRef,
    useState,
} from "react";
import { Link } from "react-router-dom";
import { Icon } from "@onshopfront/components";
import { useDeveloperDispatch, useDeveloperSelector } from "../../_Bootstrap/hooks";
import { logoutUser } from "../../Actions/UserActions";
import { Logo } from "./Logo";

const NavigationMobile: FC = () => {
    const user = useDeveloperSelector(state => state.user.user);
    const dispatch = useDeveloperDispatch();

    const [ open, setOpen ] = useState(false);
    const [ height, setHeight ] = useState(0);

    const navRef = useRef<HTMLUListElement>(null);

    const onToggle = (): void => {
        if(!navRef.current) {
            return;
        }

        if(open) {
            setOpen(false);
            setHeight(0);
        } else {
            setOpen(true);
            setHeight(navRef.current.scrollHeight);
        }
    };

    const onNavigate = (): void => {
        setHeight(0);
        setOpen(false);
    };

    let userComponent: ReactNode = null;

    if(user !== false) {
        userComponent = (
            <div className="flex-1 text-right text-neutral-100">
                <Icon
                    icon={[ "fal", "user" ]}
                    className="mr-2"
                />
                {user.name}
            </div>
        );
    }

    return (
        <nav className="shadow-lg">
            <div className="flex justify-between space-x-4 pr-4">
                <Logo />
                {userComponent}
                <div
                    className="menu-toggle"
                    onClick={onToggle}
                >
                    <Icon
                        icon={[ "fal", open ? "times" : "bars" ]}
                        fixedWidth
                    />
                </div>
            </div>
            <div
                className={
                    "relative h-0 w-screen transition-all box-border overflow-hidden bg-neutral-100" + (
                        open ?
                            " border-b border-b-neutral-300" :
                            ""
                    )
                }
                style={{
                    height: `${height}px`,
                }}
            >
                <ul
                    ref={navRef}
                    className="absolute top-0 left-0 right-0 m-0 p-6 list-none box-border space-y-2"
                >
                    <li>
                        <Link
                            to="/documentation"
                            onClick={onNavigate}
                            className={
                                "block no-underline text-neutral-800 w-full p-2 text-base text-left rounded " +
                                "bg-transparent hover:bg-black/10"
                            }
                        >
                            <Icon
                                icon={[ "fal", "book" ]}
                                className="mr-2"
                            />
                            Documentation
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/applications"
                            onClick={onNavigate}
                            className={
                                "block no-underline text-neutral-800 w-full p-2 text-base text-left rounded " +
                                "bg-transparent hover:bg-black/10"
                            }
                        >
                            <Icon
                                icon={[ "fal", "code" ]}
                                className="mr-2"
                            />
                            Applications
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/partner"
                            onClick={onNavigate}
                            className={
                                "block no-underline text-neutral-800 w-full p-2 text-base text-left rounded " +
                                "bg-transparent hover:bg-black/10"
                            }
                        >
                            <Icon
                                icon={[ "fal", "hat-cowboy" ]}
                                className="mr-2"
                            />
                            Partner Program
                        </Link>
                    </li>
                    {user === false && (
                        <li>
                            <Link
                                to="/register"
                                onClick={onNavigate}
                                className={
                                    "block no-underline text-neutral-800 w-full p-2 text-base text-left rounded " +
                                    "bg-transparent hover:bg-black/10"
                                }
                            >
                                <Icon
                                    icon={[ "fal", "user-plus" ]}
                                    className="mr-2"
                                />
                                Register
                            </Link>
                        </li>
                    )}
                    {typeof user !== "boolean" && (
                        <li>
                            <Link
                                to="/account"
                                onClick={onNavigate}
                                className={
                                    "block no-underline text-neutral-800 w-full p-2 text-base text-left rounded " +
                                    "bg-transparent hover:bg-black/10"
                                }
                            >
                                <Icon
                                    icon={[ "fal", "user" ]}
                                    className="mr-2"
                                />
                                Account Details
                            </Link>
                        </li>
                    )}
                    <li>
                        {user ? (
                            <button
                                onClick={() => {
                                    dispatch(logoutUser());

                                    onNavigate();
                                }}
                                className={
                                    "block no-underline text-neutral-800 w-full p-2 text-base text-left rounded " +
                                    "bg-transparent hover:bg-black/10"
                                }
                            >
                                <Icon
                                    icon={[ "fal", "sign-out" ]}
                                    className="mr-2"
                                />
                                Sign Out
                            </button>
                        ) : (
                            <Link
                                to="/login"
                                onClick={onNavigate}
                                className={
                                    "block no-underline text-neutral-800 w-full p-2 text-base text-left rounded " +
                                    "bg-transparent hover:bg-black/10"
                                }
                            >
                                <Icon
                                    icon={[ "fal", "sign-in" ]}
                                    className="mr-2"
                                />
                                Log In
                            </Link>
                        )}
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default NavigationMobile;
